import {ExternalVideoType} from '../../@types';
import {ExternalHosting}   from './@types';
import {rutubeHosting}     from './rutube';
import {vkvideoHosting}    from './vkvideo';
import {dzenHosting}       from './dzen';


export const EXTERNAL_HOSTINGS: Record<ExternalVideoType, ExternalHosting> = {
    rutube:  rutubeHosting,
    vkvideo: vkvideoHosting,
    dzen:    dzenHosting,
};
